import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PdfJob } from '../models/pdf-job.interface';
import { AoAuthService } from '@ah-oh/company-auth';
import { FindPdfJobsDto } from '../dtos/find-pdf-jobs.dto';

@Injectable({
    providedIn: 'root',
})
export class PdfApiService {
    private static readonly BASE_URL = environment.api + 'pdf-management';

    constructor(
        private readonly http: HttpClient,
        private readonly authService: AoAuthService,
    ) {}

    public downloadPdf({ jobId }: { jobId: string }): Observable<any> {
        return this.http.get(`${PdfApiService.BASE_URL}/${this.authService.companyId}/${jobId}`, {
            responseType: 'blob',
            observe: 'response',
        });
    }

    public findAllPdfJobs(dto: FindPdfJobsDto): Observable<PdfJob[]> {
        let params: HttpParams = new HttpParams();
        for (const [key, value] of Object.entries(dto)) {
            params = params.append(key, String(value));
        }

        return this.http.get<PdfJob[]>(`${PdfApiService.BASE_URL}/${this.authService.companyId}`, { params });
    }

    public delete({ jobId }: { jobId: string }): Observable<PdfJob> {
        return this.http.delete<PdfJob>(`${PdfApiService.BASE_URL}/${this.authService.companyId}/${jobId}`);
    }
}
